import React from 'react';
import { Box, Link, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { useI18n } from "../../../../i8n/useI18n";
import { useFooterSectionStyles } from "./FooterSection.styles";

const FooterSection = () => {
    const { t } = useI18n();
    const { classes } = useFooterSectionStyles();

    const columns = [
        {
            title: t("footerText.shopTitle"),
            links: [
                { name: t("footerText.allProducts"), href: t("links.shop") },
                { name: t("footerText.shopObjects"), href: t("links.shopObjects") },
                { name: t("footerText.shopLighting"), href: t("links.shopLighting") },
                { name: t("footerText.shopFurniture"), href: t("links.shopFurniture") },
                { name: t("footerText.shopTextiles"), href: t("links.shopTextiles") },
            ],
        },
        {
            title: t("footerText.contentTitle"),
            links: [
                { name: t("footerText.blog"), href: t("links.blog") },
                { name: t("footerText.contact"), href: t("links.contact") },
            ],
        },
        {
            title: t("footerText.legalTitle"),
            links: [
                { name: t("footerText.imprint"), href: t("links.imprint") },
                { name: t("footerText.privacy"), href: t("links.privacy") },
                { name: t("footerText.terms"), href: t("links.terms") },
            ],
        },
    ];

    return (
        <Box component="footer" className={classes.root}>
            <Box className={classes.container}>
                <Box className={classes.brandRow}>
                    <Typography variant="h5">{t("brand.name")}</Typography>
                </Box>
                <Typography variant="body2" className={classes.description}>
                    {t("footerText.description")}
                </Typography>

                <Box className={classes.columns}>
                    {columns.map((column) => (
                        <Box key={column.title}>
                            <Typography className={classes.columnTitle}>{column.title}</Typography>
                            <Box className={classes.columnLinks}>
                                {column.links.map((link) => (
                                    <Link key={link.name} component={RouterLink} to={link.href} className={classes.columnLink}>
                                        {link.name}
                                    </Link>
                                ))}
                            </Box>
                        </Box>
                    ))}
                    <Box>
                        <Typography className={classes.columnTitle}>{t("contactPage.overline")}</Typography>
                        <Box className={classes.columnLinks}>
                            <Typography component="a" href={`mailto:${t("contactPage.email")}`} className={classes.columnLink}>
                                {t("contactPage.email")}
                            </Typography>
                            <Typography component="a" href={`tel:${t("contactPage.phoneNumber")}`} className={classes.columnLink}>
                                {t("contactPage.phoneNumber")}
                            </Typography>
                        </Box>
                    </Box>
                </Box>

                <Box className={classes.bottomBar}>
                    <Typography className={classes.copyright}>
                        © {new Date().getFullYear()} {t("footerText.copyright")}
                    </Typography>
                    <Box className={classes.legalLinks}>
                        <Link component={RouterLink} to={t("links.imprint")} className={classes.legalLink}>
                            {t("footerText.imprint")}
                        </Link>
                        <Typography className={classes.legalDot}>•</Typography>
                        <Link component={RouterLink} to={t("links.privacy")} className={classes.legalLink}>
                            {t("footerText.privacy")}
                        </Link>
                        <Typography className={classes.legalDot}>•</Typography>
                        <Link component={RouterLink} to={t("links.terms")} className={classes.legalLink}>
                            {t("footerText.terms")}
                        </Link>
                    </Box>
                </Box>
            </Box>
        </Box>
    );
};

export default FooterSection;
